module.exports = __webpack_public_path__ + "static/media/instagram.0a6fc256.svg";